export default __webpack_public_path__ + "static/0700-b7894b9cdd811815ba00b9ee9716a3e4.jpg";